<template>
  <BaseModal :open="open" maxWidth="720px" :closeOnBackdrop="false" @close="$emit('close')">
    <div ref="docModal"
         class="v2026-adm"
         role="dialog"
         aria-modal="true"
         aria-labelledby="v2026-adm-title"
         @keydown.tab="trapTab">
      <div class="v2026-adm__head">
        <span id="v2026-adm-title" class="v2026-adm__title">
          {{ mode === 'edit' ? 'แก้ไขข้อมูล' : 'เพิ่มเอกสารใหม่' }}
        </span>
        <span v-if="mode === 'edit' && document" class="v2026-adm__id">ID {{ document.id }}</span>
        <button type="button" class="v2026-adm__x" aria-label="ปิด" @click="$emit('close')">×</button>
      </div>

      <div class="v2026-adm__body">
        <div class="v2026-adm__field">
          <span id="v2026-adm-lang-lbl" class="v2026-adm__label">ภาษาของเอกสาร</span>
          <div class="v2026-adm__radios" role="radiogroup" aria-labelledby="v2026-adm-lang-lbl">
            <label class="v2026-adm__radio">
              <input ref="langFirst" type="radio" name="v2026-adm-lang" value="th" v-model="language">
              <span>ภาษาไทย</span>
            </label>
            <label class="v2026-adm__radio">
              <input type="radio" name="v2026-adm-lang" value="en" v-model="language">
              <span>ภาษาอังกฤษ</span>
            </label>
          </div>
        </div>

        <div class="v2026-adm__field">
          <span id="v2026-adm-catmode-lbl" class="v2026-adm__label">หมวดหมู่เอกสาร</span>
          <div class="v2026-adm__radios" role="radiogroup" aria-labelledby="v2026-adm-catmode-lbl">
            <label class="v2026-adm__radio">
              <input type="radio" name="v2026-adm-catmode" :value="false" v-model="otherInput" @change="onSelectExisting">
              <span>เลือกจากหมวดหมู่ที่มีอยู่</span>
            </label>
            <label class="v2026-adm__radio">
              <input type="radio" name="v2026-adm-catmode" :value="true" v-model="otherInput" @change="onSelectNew">
              <span>สร้างหมวดหมู่ใหม่</span>
            </label>
          </div>
          <select v-if="!otherInput"
                  id="v2026-adm-cat"
                  class="v2026-adm__select"
                  :class="{ 'is-invalid': !!errors.category }"
                  v-model="selectedCategory"
                  @change="errors.category = ''">
            <option v-for="(category, index) in categories"
                    :key="index"
                    :value="category">{{ category || 'ยังไม่ระบุหมวดหมู่' }}</option>
          </select>
          <input v-else
                 id="v2026-adm-cat-new"
                 type="text"
                 class="v2026-adm__input"
                 :class="{ 'is-invalid': !!errors.category }"
                 placeholder="ระบุหมวดหมู่เอกสาร"
                 v-model="selectedCategory"
                 @input="errors.category = ''">
          <div v-if="errors.category" class="v2026-adm__err">{{ errors.category }}</div>
        </div>

        <div class="v2026-adm__field">
          <label class="v2026-adm__label" for="v2026-adm-body">
            ข้อมูลเอกสาร<span class="v2026-adm__req" aria-hidden="true"> *</span>
          </label>
          <textarea id="v2026-adm-body"
                    ref="bodyInput"
                    class="v2026-adm__textarea"
                    :class="{ 'is-invalid': !!errors.message }"
                    rows="12"
                    placeholder="ใส่ข้อมูลเอกสาร"
                    :aria-invalid="errors.message ? 'true' : 'false'"
                    v-model="message"
                    @input="errors.message = ''"></textarea>
          <div v-if="errors.message" class="v2026-adm__err">{{ errors.message }}</div>
        </div>
      </div>

      <div class="v2026-adm__foot">
        <button type="button" class="v2026-adm__btn-ghost" @click="$emit('close')">ยกเลิก</button>
        <button type="button"
                class="v2026-adm__btn-primary"
                :disabled="saving"
                @click="submit">{{ saving ? 'กำลังโหลด...' : 'บันทึก' }}</button>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '../coversation/BaseModal'

export default {
  name: 'ai-document-form-modal-v2026',
  components: { BaseModal },
  props: {
    open: { type: Boolean, default: false },
    mode: { type: String, default: 'create' },
    document: { type: Object, default: null },
    categories: { type: Array, default: () => [] },
    saving: { type: Boolean, default: false }
  },
  data () {
    return {
      language: 'th',
      otherInput: false,
      selectedCategory: null,
      message: '',
      errors: {
        message: '',
        category: ''
      }
    }
  },
  watch: {
    open (isOpen) {
      if (!isOpen) return
      this.resetForm()
      this.$nextTick(() => {
        if (this.$refs.langFirst) this.$refs.langFirst.focus()
      })
    }
  },
  methods: {
    resetForm () {
      this.errors = { message: '', category: '' }
      this.otherInput = false
      if (this.mode === 'edit' && this.document) {
        this.language = this.document.language || 'th'
        this.selectedCategory = this.document.category
        this.message = this.document.detail || ''
        return
      }
      this.language = 'th'
      this.selectedCategory = this.categories.length ? this.categories[0] : null
      this.message = ''
    },
    onSelectExisting () {
      this.selectedCategory = this.categories.length ? this.categories[0] : null
      this.errors.category = ''
    },
    onSelectNew () {
      this.selectedCategory = ''
      this.errors.category = ''
    },
    submit () {
      if (this.saving) return
      this.errors = { message: '', category: '' }
      const message = String(this.message || '').trim() ? this.message : ''
      if (!message) this.errors.message = 'กรุณากรอกข้อมูลเอกสาร'
      // Same gate as the bootstrap dialog: only an empty string is invalid. null (ยังไม่ระบุหมวดหมู่) saves.
      if (this.selectedCategory === '') this.errors.category = 'กรุณากรอกหมวดหมู่เอกสาร หรือเลือกจากที่มีอยู่'
      if (this.errors.message || this.errors.category) {
        this.$nextTick(() => {
          if (this.errors.message && this.$refs.bodyInput) this.$refs.bodyInput.focus()
        })
        return
      }
      this.$emit('submit', {
        message: this.message,
        category: this.selectedCategory,
        language: this.language
      })
    },
    trapTab (e) {
      const root = this.$refs.docModal
      if (!root) return
      const sel = 'button:not([disabled]), [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      const items = Array.prototype.slice.call(root.querySelectorAll(sel))
      if (!items.length) return
      const first = items[0]
      const last = items[items.length - 1]
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault()
        last.focus()
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault()
        first.focus()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* Only the ten --v2026-color-* tokens declared on .v2026-shell resolve under /settings, so every
   grey below is hard-coded on purpose. */
.v2026-adm {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  background: #ffffff;
  border-radius: 24px;
  overflow: hidden;
}

.v2026-adm__head {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 56px;
  padding: 0 20px;
  border-bottom: 1px solid #e9ecef;
}

.v2026-adm__title {
  font-size: 15px;
  font-weight: 600;
  color: #212529;
}

.v2026-adm__id {
  font-size: 13px;
  color: #66696C;
}

.v2026-adm__x {
  margin-left: auto;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 6px;
  background: none;
  font-size: 18px;
  line-height: 1;
  color: #66696C;
  cursor: pointer;

  &:hover { background: var(--v2026-color-hover-bg); color: #212529; }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
}

.v2026-adm__body {
  flex: 1 1 auto;
  padding: 20px;
  overflow-y: auto;
  max-height: calc(90vh - 120px);
}

.v2026-adm__field { margin-bottom: 16px; }

.v2026-adm__label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #343a40;
}

.v2026-adm__req { color: #E5484D; }

.v2026-adm__radios {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 8px;
}

.v2026-adm__radio {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 14px;
  color: #212529;
  cursor: pointer;

  input { margin: 0; }
}

.v2026-adm__input,
.v2026-adm__select,
.v2026-adm__textarea {
  width: 100%;
  border: 1px solid #E4E7EC;
  border-radius: 8px;
  background: #ffffff;
  font-size: 14px;
  color: #212529;

  &:focus {
    outline: none;
    border-color: var(--v2026-color-main);
    box-shadow: 0 0 0 3px rgba(49, 193, 215, .30);
  }
  &.is-invalid {
    border-color: #E5484D;
    &:focus { border-color: #E5484D; box-shadow: 0 0 0 3px rgba(229, 72, 77, .20); }
  }
}

.v2026-adm__input,
.v2026-adm__select {
  height: 36px;
  padding: 0 12px;
}

.v2026-adm__textarea {
  display: block;
  min-height: 220px;
  padding: 10px 12px;
  line-height: 1.5;
  resize: vertical;
}

.v2026-adm__err {
  margin-top: 6px;
  font-size: 12px;
  color: #E5484D;
}

.v2026-adm__foot {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  height: 64px;
  padding: 0 20px;
  border-top: 1px solid #e9ecef;
}

.v2026-adm__btn-primary {
  height: 36px;
  padding: 0 14px;
  border: 0;
  border-radius: 8px;
  background: var(--v2026-color-main);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover:not(:disabled) { filter: brightness(.94); }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
  &:disabled { opacity: .5; cursor: default; }
}

.v2026-adm__btn-ghost {
  height: 36px;
  padding: 0 14px;
  border: 1px solid #E4E7EC;
  border-radius: 8px;
  background: #ffffff;
  font-size: 14px;
  color: #212529;
  cursor: pointer;
  white-space: nowrap;

  &:hover:not(:disabled) { background: var(--v2026-color-hover-bg); }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
}
</style>
